import React from "react";
import classNames from "classnames";

type PropsTypeButton = {
  children: string;
  activeClassName?: any;
  className?: string;
  active?: boolean;
  error?: boolean;
};

function KeyboardButton({
  children,
  activeClassName,
  className,
  active,
  error,
}: PropsTypeButton) {
  return (
    <div
      className={classNames(
        [className],
        {
          [activeClassName]: active,
        },
        {
          "key-active font-bold": active,
        },
        {
          "!bg-red": error,
        },
        {
          "!justify-start !pl-2 !pr-4": /\s/g.test(children),
        },
        "key",
      )}
    >
      {children}
    </div>
  );
}

export default KeyboardButton;
